<template>
    <div class="m-2">
        <FormInput label="Fecha" name="fecha" id="fecha" type="date" v-model="sancion.fecha" rules="required"/>
        <FormInput label="Sin jugar hasta" name="sin_jugar_hasta" id="fecha" type="date" v-model="sancion.sin_jugar_hasta" rules="required"/>
        <FormInput label="Motivo" name="motivo" id="motivo" type="text" v-model="sancion.motivo" rules="required"/>
        <FormInput label="Descripción" name="descripcion" id="descripcion" type="text" v-model="sancion.descripcion" rules="required"/>
        <FormInput label="Sanción" name="sancion" id="sancion" type="text" v-model="sancion.sancion" rules="required"/>
        <FormInput label="Importe" name="importe" id="importe" type="number" v-model="sancion.importe" rules="required"/>
        <label for="impuesta">Sanción impuesta por</label>
        <ValidationProvider name="impuesta" id="impuesta" rules="required" v-slot="{ errors }">
            <multiselect
                v-model="sancion.impuesta"
                :options="sancionadores"
                placeholder="Sanción impuesta por"
                track-by="id"
                label="nombre"
                :max-height="150"
                :class="errors.length == 0 ? 'mb-3' : ''"
            />
            <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errors[0] }}</b></span>
        </ValidationProvider>
        <label for="pagar">Tiene que pagar la sanción</label>
        <ValidationProvider name="pagar" id="pagar" rules="required" v-slot="{ errors }">
            <multiselect
                v-model="sancion.pagar"
                :options="deudores"
                placeholder="Tiene que pagar la sanción"
                track-by="id"
                label="nombre"
                :max-height="150"
                :class="errors.length == 0 ? 'mb-3' : ''"
            />
            <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errors[0] }}</b></span>
        </ValidationProvider>
        <label for="pagar">Sanción pagada</label>
        <ValidationProvider name="pagado" id="pagado" rules="required" v-slot="{ errors }">
            <multiselect
                v-model="sancion.pagado"
                :options="pagada"
                placeholder="Sanción pagada"
                track-by="id"
                label="nombre"
                :max-height="150"
                :class="errors.length == 0 ? 'mb-3' : ''"
            />
            <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errors[0] }}</b></span>
        </ValidationProvider>
    </div>
</template>

<script>
    export default {
        props: [
            'sancion'
        ],
        data() {
            return {
                sancionadores: [
                    { id: 0, nombre: 'Federación' },
                    { id: 1, nombre: 'Club' },
                    { id: 2, nombre: 'Cuerpo técnico' }
                ],
                deudores: [
                    { id: 0, nombre: 'Club' },
                    { id: 1, nombre: 'Deportista' }
                ],
                pagada: [
                    { id: 1, nombre: 'Pagado' },
                    { id: 0, nombre: 'No pagado' }
                ]
            }
        }
    }
</script>